module.exports = __webpack_public_path__ + "img/hourglass-grey56.e38f9141.svg";